import React, { useState } from 'react';
import {
  Box,
  Typography,
  Collapse,
  IconButton,
  Paper,
  Stack
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const methodColors = {
  GET: '#2196f3',
  POST: 'primary.main',
  PUT: '#ff9800',
  DELETE: '#f44336'
};

const ApiEndpointBlock = ({ method = 'GET', path = '', description, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <Paper variant="outlined" sx={{ my: 2, p: 1.5, backgroundColor: '#f0f8ff', borderLeft: `5px solid ${methodColors[method] || '#333'}` }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center" spacing={2}>
          <Box
            sx={{
              px: 1.5,
              py: 0.5,
              backgroundColor: methodColors[method] || '#333',
              color: '#fff',
              borderRadius: '4px',
              fontWeight: 'bold',
              fontSize: '0.8rem'
            }}
          >
            {method}
          </Box>
          <Typography variant="body1" sx={{ fontFamily: 'monospace' }}>
            {path}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </Stack>
        <IconButton onClick={() => setOpen(!open)}>
          {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Stack>

      <Collapse in={open}>
        <Box mt={2} px={1}>
          {children}
        </Box>
      </Collapse>
    </Paper>
  );
};

export default ApiEndpointBlock;
